import { logger } from '@/lib/logger';
import type { PartialBlock } from '@/types';

const TRACE_BLOCK_IDS =
  process.env.NEXT_PUBLIC_TRACE_BLOCK_IDS === 'true' ||
  process.env.TRACE_BLOCK_IDS === 'true';

const buildPreview = (blocks: unknown): Array<Record<string, unknown>> => {
  if (!Array.isArray(blocks)) {
    return [];
  }

  return blocks.slice(0, 10).map((raw, index) => {
    const block = raw as PartialBlock & Record<string, unknown>;
    return {
      index,
      id: block?.id ?? null,
      type: block?.type ?? null,
      hasContentArray: Array.isArray(block?.content),
      hasProps: !!(block && typeof block === 'object' && Object.keys(block.props ?? {}).length > 0),
    };
  });
};

export const traceBlocks = (
  context: string,
  blocks: unknown,
  metadata?: Record<string, unknown>
): void => {
  if (!TRACE_BLOCK_IDS) {
    return;
  }

  const preview = buildPreview(blocks);
  const count = Array.isArray(blocks) ? blocks.length : 0;

  logger.info('block_trace', {
    context,
    count,
    preview,
    ...metadata,
  });
};
